import { render, staticRenderFns } from "./comment-creer-un-site-internet-d-avocat.vue?vue&type=template&id=6f956f48&scoped=true&"
import script from "./comment-creer-un-site-internet-d-avocat.vue?vue&type=script&lang=js&"
export * from "./comment-creer-un-site-internet-d-avocat.vue?vue&type=script&lang=js&"
import style0 from "./comment-creer-un-site-internet-d-avocat.vue?vue&type=style&index=0&id=6f956f48&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f956f48",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,Button: require('/app/components/Button.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
